@import '../../global/utility/responsive/responsive-mixins';

$sizes: 480, 360;

:host {
  @include responsive($sizes);

  display: block;

  > div {
    display: inherit;
  }

  *:first-child {
    margin-top: 0;
  }

  @extend %subsup;
}

ui-tooltip::part(icon) {
  position: relative;
}

ui-headline,
ui-leadtext {
  ui-tooltip::part(icon) {
    width: 24px;
    height: 24px;
    position: relative;
  }
}

ui-leadtext {
  ui-paragraph {
    ui-tooltip::part(icon) {
      top: 3px;
    }
  }
}

ui-paragraph {
  ui-tooltip::part(icon) {
    top: 2px;
  }
}

ui-headline[level='1'] {
  margin-top: 30px;

  & + * {
    margin-top: 20px;

    @include breakpoint($medium) {
      margin-top: 28px;
    }
  }

  ui-tooltip::part(icon) {
    top: -2px;
  }

  /*
  The following should be correct regarding to those links:
  - https://www.sketch.com/s/94c5ebf9-f20a-43a2-9c69-cf9bcfc33daf/a/paqK8nR#Inspect
  - https://jira.apps.union-investment.de/browse/TMAGDXC-4892
  */

  & + ui-paragraph {
    margin-top: 14px;

    @include breakpoint($medium) {
      margin-top: 24px;
    }
  }

  & + ui-leadtext {
    margin-top: 20px;
  }
}

ui-headline[level='2'] {
  margin-top: 5px;

  @include breakpoint($medium) {
    margin-top: 25px;
  }

  & + * {
    margin-top: 20px;

    @include breakpoint($medium) {
      margin-top: 28px;
    }
  }

  ui-headline[level='1'] + & {
    margin-top: 10px;

    @include breakpoint($medium) {
      margin-top: 20px;
    }
  }

  ui-paragraph + & {
    margin-top: 26px;

    @include breakpoint($medium) {
      margin-top: 23px;
    }
  }

  ui-leadtext + & {
    margin-top: 26px;

    @include breakpoint($medium) {
      margin-top: 23px;
    }
  }

  ui-tooltip::part(icon) {
    top: 2px;
  }
}

ui-headline[level='3'] {
  margin-top: 5px;

  @include breakpoint($medium) {
    margin-top: 25px;
  }

  & + * {
    margin-top: 8px;

    @include breakpoint($medium) {
      margin-top: 12px;
    }
  }

  ui-headline[level='1'] + & {
    margin-top: 10px;

    @include breakpoint($medium) {
      margin-top: 20px;
    }
  }

  ui-paragraph + & {
    margin-top: 26px;

    @include breakpoint($medium) {
      margin-top: 23px;
    }
  }

  ui-leadtext + & {
    margin-top: 26px;

    @include breakpoint($medium) {
      margin-top: 23px;
    }
  }

  ui-tooltip::part(icon) {
    top: 4px;
  }
}

ui-headline[level='4'] {
  margin-top: 5px;

  @include breakpoint($medium) {
    margin-top: 25px;
  }

  & + * {
    margin-top: 8px;

    @include breakpoint($medium) {
      margin-top: 12px;
    }
  }

  ui-headline[level='1'] + & {
    margin-top: 10px;

    @include breakpoint($medium) {
      margin-top: 20px;
    }
  }

  ui-headline[level='3'] + & {
    margin-top: 8px;

    @include breakpoint($medium) {
      margin-top: 12px;
    }
  }

  ui-paragraph + & {
    margin-top: 28px;
  }

  ui-leadtext + & {
    margin-top: 28px;
  }

  ui-tooltip::part(icon) {
    width: 16px;
    height: 16px;
    top: 2px;
  }
}

ui-paragraph,
ui-leadtext {
  ui-headline[level='2'] + &,
  ui-headline[level='3'] + &,
  ui-headline[level='4'] + & {
    margin-top: 16px;
  }

  ui-paragraph + & {
    margin-top: 8px;

    @include breakpoint($medium) {
      margin-top: 12px;
    }
  }

  ui-leadtext + & {
    margin-top: 28px;
  }

  ui-list + & {
    margin-top: 20px;
  }
}

ui-list {
  margin-top: 16px;
}

:host([floating]) {
  > div > {
    *:not(ui-leadtext) {
      /* stylelint-disable-next-line plugin/no-unsupported-browser-features */
      column-count: 0;
    }

    ui-list {
      /* stylelint-disable-next-line plugin/no-unsupported-browser-features */
      column-count: 1;
    }
  }
}
